import React from 'react';
import { useNavigate } from 'react-router-dom';

const ServicesSection: React.FC = () => {
  const navigate = useNavigate();
  
  const services = [
    {
      icon: 'ri-dna-line',
      title: '基因组学分析',
      description: '全基因组测序、外显子测序、基因变异检测等专业基因组学数据分析服务',
      features: ['WGS/WES分析', '变异检测', '功能注释', '结构变异']
    },
    {
      icon: 'ri-bar-chart-line',
      title: '转录组学分析',
      description: 'RNA-seq数据分析、差异表达基因筛选、功能富集分析等专业服务',
      features: ['差异表达', '功能富集', '共表达网络', '可变剪接']
    },
    {
      icon: 'ri-microscope-line',
      title: '蛋白质组学分析',
      description: '蛋白质鉴定与定量、修饰分析、相互作用网络等专业分析服务',
      features: ['蛋白鉴定', '定量分析', 'PTM分析', '相互作用']
    },
    {
      icon: 'ri-medicine-bottle-line',
      title: '代谢组学分析',
      description: '代谢物鉴定与定量、代谢通路分析、生物标志物发现等服务',
      features: ['代谢物鉴定', '通路分析', '标志物筛选', '网络构建']
    },
    {
      icon: 'ri-test-tube-line',
      title: '测序服务',
      description: '提供全方位的高通量测序服务，采用先进测序平台和专业技术团队确保数据质量',
      features: ['表观组测序', '转录组测序', '基因组测序', '蛋白组测序']
    },
    {
      icon: 'ri-test-tube-fill',
      title: '湿实验服务',
      description: '提供专业的分子、细胞生物学等实验服务和各类实验技术支持',
      features: [
        '细胞培养与处理',
        'PCR扩增与检测',
        '蛋白表达分析',
        '基因功能验证'
      ]
    },
    {
      icon: 'ri-git-merge-line',
      title: '多组学整合分析',
      description: '整合多组学数据，构建系统级生物网络模型，解析复杂生物过程的分子调控机制',
      features: ['数据整合', '网络构建', '通路分析', '系统建模']
    },
    {
      id: 'ai-analysis',
      icon: 'ri-brain-line',
      title: '机器/深度学习',
      description: '基于机器学习和深度学习算法进行多模态建模与AI分析预测',
      features: [
        '经典机器学习算法',
        '深度学习框架应用',
        'AI模型搭建',
        '算法优化与创新'
      ]
    },
    {
      icon: 'ri-lightbulb-line',
      title: '研究思路指导',
      description: '提供专业的研究思路梳理、实验设计优化、创新点挖掘指导',
      features: ['方向规划', '实验设计', '创新挖掘', '逻辑梳理']
    },
    {
      icon: 'ri-edit-line',
      title: '论文润色服务',
      description: '专业英文润色、图表设计，确保语言表达的准确性与学术性',
      features: ['英文润色', '图表设计', '格式规范', '投稿指导']
    }
  ];

  const handleViewAllServices = () => {
    navigate('/services');
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            专业的<strong>科研服务</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            从<strong>湿实验</strong>到<strong>数据分析</strong>，从<strong>测序服务</strong>到<strong>学术发表</strong>，我们提供全链条的科研支持服务
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mb-4">
                <i className={`${service.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-4 leading-relaxed text-sm">{service.description}</p>
              <div className="space-y-2">
                {service.features?.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-center text-xs text-gray-500">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {feature}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <button 
            onClick={handleViewAllServices}
            className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-right-line mr-2"></i>
            查看全部服务
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
